import { render, staticRenderFns } from "./UploadFAQ.vue?vue&type=template&id=d4e05be0"
import script from "./UploadFAQ.vue?vue&type=script&lang=js"
export * from "./UploadFAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports